module.exports = __webpack_public_path__ + "img/apple-macbook.369954eb.jpg";